import { calcQuantityDiscountPrice } from "public/utils/calc-quantity-discount-price";
/**
 * @param {Object} args
 * @param {Object[]} args.variationItems
 * @returns {Map<string, number>}
 */
export function transformVariationItemToPriceMapByAspectKey(args) {
  const { variationItems } = args;
  const map = new Map();

  variationItems.forEach((variationItem) => {
    const { variant } = variationItem;

    const aspectKey = transformVariationItemToAspectKey({
      variationItem,
    });

    map.set(aspectKey, variant.price);
  });

  return map;
}

/**
 * @param {Object} args
 * @param {Map<string, number>} args.priceMapByAspectKey
 * @param {Object} args.offer
 * @returns {Map<string, number>}
 */
export function transformPriceMapByAspectKeyToDiscountPriceMapByAspectKey(
  args
) {
  const { priceMapByAspectKey, offer } = args;
  const map = new Map();

  let aspectKeys = priceMapByAspectKey.keys();

  while (true) {
    const aspectKey = aspectKeys.next();

    if (aspectKey.done) break;

    const price = priceMapByAspectKey.get(aspectKey.value);

    if (!price) {
      continue;
    }

    const discountPrice = calcQuantityDiscountPrice({
      quantity: offer.quantityFrom,
      price,
      offer,
    });

    map.set(aspectKey.value, discountPrice);
  }

  return map;
}

/**
 * @param {Object} args
 * @param {Object} args.variationItem
 * @returns {string}
 */
function transformVariationItemToAspectKey(args) {
  const { variationItem } = args;
  let aspectKey = "";

  for (const [key, value] of Object.entries(variationItem.choices)) {
    if (aspectKey) {
      aspectKey += "/";
    }

    aspectKey += `${key}:${value}`;
  }

  aspectKey = aspectKey.replace(/\s/g, "");
  aspectKey = aspectKey.toLowerCase();

  return aspectKey;
}
